module.exports = __webpack_public_path__ + "img/the-ultimate-guide-to-game-development-with-unity.abb85630.png";